import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {ErrorFallback} from "@/lib/handlers/ErrorFallback.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {DashboardDefinition} from "@/lib/types/website.ts";
import {DashboardDisplay} from "@/pages/dashboard/display/DashboardDisplay.tsx";
import {DashboardFormDefaults} from "@/pages/dashboard/edit/dashboardForm.ts";

export const DashboardPageNew = () => {
  const dashboardDefaults = {id: 0, ...DashboardFormDefaults} as DashboardDefinition;

  return (
    <UpErrorBoundary
      fallback={
        <ContentContainer title={dashboardDefaults.name}>
          <ErrorFallback />
        </ContentContainer>
      }
    >
      <DashboardDisplay dashboardDef={dashboardDefaults} isNew={true} />
    </UpErrorBoundary>
  );
};
